const DEFAULT_FONT = "16px sans-serif"

const getTextWidth = text => {
  const element = document.createElement("canvas")
  const context = element.getContext("2d")
  const { body } = document

  let font = DEFAULT_FONT

  const isReadyToGetComputedStyle =
    body &&
    body instanceof Element &&
    typeof getComputedStyle === "function"

  if (isReadyToGetComputedStyle) {
    font = getComputedStyle(body).font || DEFAULT_FONT
  }

  context.font = font

  const { width } = context.measureText(text)

  return Number(width)
}

export default getTextWidth
